import 'twin.macro'

import StepCircle from 'assets/images/landing/step-circle.svg?component'
import { motion } from 'framer-motion'
import CountUp from 'react-countup'
import { useTranslation } from 'react-i18next'
import { stepsAnimationVariants, stepsExitAnimation, stepsInitAnimation } from 'utils/constants'

const StepAnimationItem = ({ seconds }: { seconds: number }) => {
  const { t } = useTranslation('landing')

  return (
    <motion.div
      initial={stepsInitAnimation}
      variants={stepsAnimationVariants}
      exit={stepsExitAnimation}
      animate='popIn'
    >
      <div tw='h-[167px] overflow-hidden'>
        <motion.div className='h-[334px]' variants={stepsAnimationVariants} animate='rotateProgress'>
          <StepCircle />
        </motion.div>
      </div>
      <CountUp
        delay={1}
        duration={6}
        start={0}
        end={seconds}
        className='text-[55px] font-semibold sm:text-[64px] sm:leading-[125%] text-[var(--text-title)] absolute top-20 left-1/2 -translate-x-1/2'
      />
      <p className='text-xl font-semibold sm:text-2xl sm:leading-[29px] text-[var(--text-seconds)] absolute top-40 left-1/2 -translate-x-1/2'>
        {t('steps-section.seconds')}
      </p>
    </motion.div>
  )
}

export default StepAnimationItem
